﻿import { ApiCaller } from 'apis/ApiCaller';

export interface EarlyAccessRing {
	Description: string;
	Id: number;
	Name: string;
}

/**
 * Represents an api handler for the EarlyAccessRingController.
 * */
export class EarlyAccessRingApi {

    /**The api caller to use for HTTP requests. */
    private static apiCaller = new ApiCaller('EarlyAccessRing');

    /**
		 * Get all early access rings.
		 * */
    public static GetAll() : Promise<EarlyAccessRing[]> {

		    return this.apiCaller.GET<EarlyAccessRing[]>('GetAll');

    }

}